import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { TableListComponent } from './table-list/table-list.component';
import { TypographyComponent } from './typography/typography.component';
import { IconsComponent } from './icons/icons.component';
import { MapsComponent } from './maps/maps.component';
import { NotificationsComponent } from './notifications/notifications.component';
import {AuthGuard} from "./services/auth.guard";
const routes: Routes =[
    { path: 'user-profile',   component: UserProfileComponent, canActivate: [AuthGuard]  },
    { path: 'table-list',     component: TableListComponent , canActivate: [AuthGuard] },
    { path: 'typography',     component: TypographyComponent , canActivate: [AuthGuard] },
    { path: 'icons',          component: IconsComponent, canActivate: [AuthGuard]  },
    { path: 'maps',           component: MapsComponent, canActivate: [AuthGuard]  },
    { path: 'notifications',  component: NotificationsComponent, canActivate: [AuthGuard]  },
    { path: 'dashboard',  component: DashboardComponent, canActivate: [AuthGuard] },
    { path: '',  redirectTo: 'dashboard', pathMatch: 'full' },
    {
        path: 'projects',
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: './projects/projects.module#ProjectsModule'
            }
        ]
    },
    {
        path: 'auth',
        children: [
            {
                path: '',
                loadChildren: './auth/auth.module#AuthModule'
            }
        ]
    },
    {
        path: 'freelancers',
        children: [
            {
                path: '',
                loadChildren: './freelancers/freelancers.module#FreelancersModule'
            }
        ]
    }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes)
  ],
  exports: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/app.routing.ts